import * as STD from '@emersya/mpa-std-lib';

import CM                from '@emersya/mpa-components-manager-lib';
import { InputButton }   from '@emersya/mpa-components-lib';

export interface IPlannerLayoutTileComponentConfiguration extends InputButton.Configuration {
	readonly iconURL : string;
};

export class PlannerLayoutTileComponent extends InputButton.Component {
	static override getInputEventSubType() {
		const parentClass = (<(typeof CM.Component) []> <any> STD.object.getInheritanceChainFromClass(this))[ 1 ];
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button');
		}
		return parentClass.type;
	};

	static override initialize() {
		super.initialize();
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IPlannerLayoutTileComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = PlannerLayoutTileComponent;
	export type Component = PlannerLayoutTileComponent;
	export type Configuration = IPlannerLayoutTileComponentConfiguration;
}
import manifestXMLSource from './PlannerLayoutOptionTile.xml';
import './PlannerLayoutOptionTile.scss';

CM.declare({
	id :       'viewer-planner-layout-optionTile',
	type :     PlannerLayoutTileComponent,
	manifest : manifestXMLSource
});
